import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-869e6c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky top-0 z-50 w-full border-b border-slate-800 bg-slate-900/80 backdrop-blur supports-[backdrop-filter]:bg-slate-900/60" }
const _hoisted_2 = { class: "container mx-auto flex h-16 items-center justify-between px-4" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold bg-gradient-to-r from-primary-400 to-primary-600 bg-clip-text text-transparent" }, " CodeCopy ", -1))
const _hoisted_5 = { class: "hidden md:flex items-center gap-6 text-sm font-medium" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<a href=\"https://algoquest.dev\" target=\"_blank\" class=\"text-slate-300 hover:text-white transition-colors flex items-center gap-1\" data-v-869e6c36> AlgoQuest <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-external-link\" data-v-869e6c36><path d=\"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6\" data-v-869e6c36></path><polyline points=\"15 3 21 3 21 9\" data-v-869e6c36></polyline><line x1=\"10\" y1=\"14\" x2=\"21\" y2=\"3\" data-v-869e6c36></line></svg></a>", 1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<button class=\"md:hidden text-slate-300 hover:text-white\" data-v-869e6c36><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-menu\" data-v-869e6c36><line x1=\"4\" x2=\"20\" y1=\"12\" y2=\"12\" data-v-869e6c36></line><line x1=\"4\" x2=\"20\" y1=\"6\" y2=\"6\" data-v-869e6c36></line><line x1=\"4\" x2=\"20\" y1=\"18\" y2=\"18\" data-v-869e6c36></line></svg></button>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center space-x-2"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "text-slate-300 hover:text-white transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/ai",
          class: "text-slate-300 hover:text-white transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode("AI Tools")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/stacks",
          class: "text-slate-300 hover:text-white transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Stacks")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "text-slate-300 hover:text-white transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        }),
        _hoisted_6
      ]),
      _hoisted_7
    ])
  ]))
}